import axios from '../axios'

// 教師のLMS在籍フラグ(lms_teacher_active)を更新（admin）
const patchTeacherActiveApi = async (teacherId, active) => {
  return await axios.patch(`api/lms/teachers/${teacherId}/active`, { active })
}

export default patchTeacherActiveApi
